(function($) {

  // Mobile flyout fix:
  // will remove explicit with that the BB Menu Module adds when closing 
  // the flyout menu

    $('.fl-menu-mobile-toggle').on('click', function() {
      $('.fl-menu-mobile-flyout').removeAttr("style");
    });

    $('#bu-markets-nav a').click(function () { // on button click
      $("html, body").animate({ // catch the `html, body`
          scrollTop: $("#home-markets").offset().top - 160 // 8th div's top offset 
      },1); // in 1000 ms (1 second)
    });
    
      var win = $(window);
    
      function bbScroll() {
        if ("undefined" != typeof FLBuilderLayoutConfig) {
          var offset = 170;
    
          if ("undefined" === typeof FLBuilderLayout) {
            return;
          }
    
          if ( FLBuilderLayout._isMobile() && win.width() < 768 ) {
            offset = 0;
          }  
          if ( FLBuilderLayout._isMobile() && win.width() < 992 ) {
            offset = 0;
          }  
    
          if ($("body.admin-bar").length > 0) {
            offset += 0;
          }
    
          FLBuilderLayoutConfig.anchorLinkAnimations.duration = 1000;
          FLBuilderLayoutConfig.anchorLinkAnimations.easing = "swing";
          FLBuilderLayoutConfig.anchorLinkAnimations.offset = offset;
        }
      }
    
      bbScroll();
      win.on("resize", bbScroll);
    
    
    $("#collapseAll").click( function(e) {
      
      e.preventDefault();
      let button = document.getElementById("collapseAll");
      if(!$('.uabb-adv-accordion-item').hasClass("uabb-adv-accordion-item-active")){
          $('.uabb-adv-accordion-item').removeClass("uabb-adv-accordion-item-active").addClass("uabb-adv-accordion-item-active");
          $('.uabb-adv-accordion-content').show();
          
          $("#collapseAll .fl-button-text").text('Collapse All').addClass('expanded').removeClass('collapsed');
    
      } else {
          $('.uabb-adv-accordion-item').addClass("uabb-adv-accordion-item-active").removeClass("uabb-adv-accordion-item-active");
          $('.uabb-adv-accordion-content').hide();
          $("#collapseAll .fl-button-text").text('Expand All').addClass('collapsed').removeClass('expanded');
      }
    });
    
    })(jQuery);